import { Routes, Route, Navigate } from "react-router-dom";
import AuthGate from "./auth/AuthGate";
import KanbanV2Page from "./pages/KanbanV2Page";
import CompaniesPage from "./pages/CompaniesPage";
import ListV2Page from "./pages/ListV2Page";
import CalendarV2Page from "./pages/CalendarV2Page";
import GanttPage from "./pages/GanttPage";
import ProfilePage from "./pages/ProfilePage";
import Dashboard from "./components/Dashboard";
import { Toaster } from "react-hot-toast";
import "./styles/design.css";

export default function App() {
  return (
    <AuthGate fallback={<div style={{ padding: 24 }}>Cargando…</div>}>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 2500,
          style: {
            borderRadius: "12px",
            border: "1px solid var(--divider, rgba(0,0,0,.12))",
            background: "var(--panel, #fff)",
            color: "var(--text, #0f172a)",
          },
        }}
      />

      <div className="app-shell">
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Dashboard />} />

            {/* ✅ ÚNICO Kanban */}
            <Route path="/kanban" element={<KanbanV2Page />} />
            {/* Back-compat si alguien usa la ruta vieja */}
            <Route path="/kanban-v2" element={<Navigate to="/kanban" replace />} />

            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/list-v2" element={<ListV2Page />} />
            <Route path="/calendar-v2" element={<CalendarV2Page />} />
            <Route path="/gantt" element={<GanttPage />} />
            <Route path="/profile" element={<ProfilePage />} />

            {/* Redirige rutas antiguas eliminadas */}
            <Route path="/kanban-compare" element={<Navigate to="/kanban" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </AuthGate>
  );
}

